export var api_urls = {
    CREATE: "/admin/account/create",
    LOGIN: "/admin/login",
    LOGOUT: "/admin/logout",
    FORGOT_PASSWORD: "/admin/forgot-password",
    RESET_PASSWORD: "/admin/reset-password",
    RESEND_PASSWORD_LINK: "/admin/resend-password-link",
    VERIFY_OTP: "/admin/verify-otp",
    REFRESH_TOKEN: "/admin/refresh-token",
    USER_PROFILE: "/admin/auth/user-profile",
    VENDOR_LIST: "/vendor/list",
    DEALER_LIST: "/vendor/users",
    ADMIN_LIST: "/admin/list",
    DEALER_PROG_ASSOCIATION_LIST: "/dealer/program/list",
    GET_DEALER_NAME: "/account/dealer-info",
    GET_DETAILS_BY_FED_TAX_ID: "/account/info",
    ACCOUNT_SEARCH: "/account/search",
    GET_LOC_APPLICATION_LIST: "/application/line-of-credit",
    GET_LOC_AMOUNTS_INFO: "/application/loc-info",
    GET_APPLICATION_DETAILS: "/application/details",
    LOCATION_LIST: "/location/list",
    LOCATION_SALES_REPS: "/location/list-salesreps",
    PROGRAM_MANAGEMENT_LIST: "/program/list",
    UPDATE_USER: "/vendor/update-user",
    DEACTIVATE_USER: "/vendor/deactive-user",
    ROLES_LIST: "/role/list",
    ROLE_PERMISSIONS: "/role/permissions",
    CREATE_ADMIN: "/admin/create",
    CREATE_DEALER_PROG_ASSOCIATION: "/dealer/program/association",
    UPDATE_ADMIN: "/admin/update",
    CREATE_PROGRAM: "/program/create",
    UPDATE_PROGRAM: "program/update",
    ADMIN_IMPERSONATE: "/admin/impersonate",
    CREATE_DEALER: "/vendor/create",
    DEALER_DETAILS_BY_ID: "/vendor/config-details",
    UPDATE_DEALER_CONFIG: "/vendor/update-config",
    DELETE_DEALER_FILES: "/vendor/remove-logos",
    MARKETING_CONTENT_SAVE: "/marketing-content/save",
    MARKETING_CONTENT_LIST: "/marketing-content/list",
    DELETE_NOTIFICATION_DATA: "/marketing-content/delete",
    PROGRAMS_LIST: "/program/list",
    PROGRAM_VENDOR_DEALERS: "/program/vendor-dealers",
    SYNC_DEALER_PROG_ASSOCIATION: "/dealer/sync",
    SYNC_PROGRAM: "/program/sync",
    GET_DESCRIPTION_OPTIONS: "/program/sync/list",
    DELETE_PROGRAM: "/program/delete/",
    DELETE_DEALER_PROG_ASSOCIATION: "/dealer/delete",
    SAVE_OR_UPDATE_FIELD_CONFIG: "/vendor/field-config",
    GET_FIELD_CONFIG_DATA: "/vendor/field-config",
    GET_FAILED_APPLICATIONS: "/admin/application/failed",
    GET_FAILED_APPLICATION_SYNC_DATA: "/admin/application/failed",
    DELETE_FAILED_APPLICATION: "/admin/application/failed",
    RESUBMIT_FAILED_APPLICATION: "/contract/re-submit",
    RESUBMIT_PRICING_APPLICATION: "/contract/pricing/re-submit",
    MICROSOFT_LOGIN: "/admin/microsoft-login",
    ADMIN_PREFERENCES: "/admin/preferences",
    GET_TOTAL_CONTRACTS: "/backlog/total-contracts",
    GET_CONTRACT_DETAILS: "/application/details",
    GET_APPLICATIONS_DETAILS: "/application/details",
    GET_APP_CREDIT_DETAILS: "/backlog/credit-adjudication",
    GET_APP_MAIN_INFO: "/backlog/application-info",
    GET_APP_ASSET_MNGMT_DETAILS: "/backlog/application-asset-managment",
    GET_APP_METADATA_DETAILS: "/backlog/application-metadata",
    GET_APP_DOCUMENTS: "/backlog/application-documents",
    UPLOAD_APP_DOCUMENT: "/backlog/upload-document",
    EXTRACT_APPLICATION_DOCUMENTS: "/application-ai-review/documents",
    DOCUMENTS_CACHE_STATUS: "/application-ai-review/documents/cache-status",
    GET_ACCOUNT_PAYABLE: "/backlog/application-account-payable",
    GET_EFT_BANK: "/backlog/application-eft-bank",
    GET_APP_LIENS: "/backlog/application-liens",
    GET_INSURANCE_DETAILS: "/backlog/application-insurance-details",
    UPDATE_BACKLOG_UDFS: "/backlog/udfs",
    UPDATE_BACKLOG_CONTRACT: "/backlog/contract",
    UPDATE_BACKLOG_ASSETS: "/backlog/asset",
    UPDATE_BACKLOG_ACCOUNTS: "/backlog/account",
    BACKLOG_APPLICATION_AI_REVIEW: "/backlog/application-ai-review",
    BACKLOG_COMMENT: "/backlog/comment",
    BACKLOG_COMMENTS: "/backlog/comments",
    FINANCE_PRODUCT: "/application/finance-product",
    GET_PRICING_DETAILS: "/quote/pricing-options",
    CREATE_APPLICATION: "/application/create",
    APPLICATION_COMMENT: "/application/comment",
    GET_ASSET_TYPE_INFO: "/application/asset-type",
    GET_STATUS_REASONS: "/application-lookup/status-reasons",
    CREATE_STATUS_REASON: "/application-lookup/status-reasons",
    ASSIGN_STATUS_REASONS: "/application-lookup/status-reasons/assign",
    OCR_DRIVER_LICENSE: "/document/ocr/driver-license",
    OCR_DEALER_INVOICE: "/document/ocr/dealer-invoice",
    UPLOAD_DOCUMENT: "/document/upload",
    DELETE_DOCUMENT: "/document/delete",
    UPLOAD_INSURANCE_POLICY_DOC: "/insurance/document",
    GET_INSURANCE_POLICY_DOC: "/insurance/document-details",
    DELETE_INSURANCE_POLICY_DOC: "/insurance/document-delete",
    GENERATE_INSURANCE_QUOTE: "/insurance/generate-quote",
    GET_INSURANCE_ENROLLMENT: "/insurance/enrollment",
    BACKLOG_PROGRAMS_LIST: "/backlog/program-list",
    BACKLOG_UNIQUE_STATUS_LIST: "/backlog/contract-status",
    BACKLOG_APPLICATION_CREDIT_REPORTS: "backlog/application-credit-reports",
    BACKLOG_REPORT_STREAM: "/backlog/report-stream",
    BACKLOG_SALES_REP: "/backlog/internal-sales-reps",
    BACKLOG_DEALER_LIST: "/backlog/dealer-list",
    GET_FUNDING_LOGS: "/funding-log/queue",
    GET_FUNDING_LOGS_COUNT: "/funding-log/queue-count",
    BACKLOG_ASSIGN_CM: "/funding-log/assign-cm",
    BACKLOG_FUNDING_LOG_L2_ASSIGNMENT: "/funding-log/l2-assignment",
    FUNDING_LOG_CONTRACT_MANAGERS: "/funding-log/contract-managers",
    GET_CONTRACT_ADJUDICATION: "/application/contract-adjudication",
    GET_FAQS: "/chatbot/list",
    CREATE_FAQ: "/chatbot/create",
    UPDATE_FAQ: "/chatbot/update",
    DELETE_FAQ: "/chatbot/delete",
    CUSTOMER_PORTAL_UPDATE_USER_STATUS: "/admin/update-user-status",
    CUSTOMER_PORTAL_USER_LIST: "/admin/list-users",
    CUSTOMER_PORTAL_UPDATE_USER: "/admin/update",
    CUSTOMER_PORTAL_GET_USER_DATA: "/admin/get-user-by-id",
    CUSTOMER_PORTAL_VERIFY_PHONE_NUMBER: "/admin/verify-phone",
    CUSTOMER_PORTAL_UPDATE_PHONE_NUMBER: "/admin/update-phone",
    CUSTOMER_PORTAL_LINK_ASSOCIATE_USERS: "/admin/link-associate-user",
    CUSTOMER_PORTAL_UNLINK_ASSOCIATE_USERS: "/admin/unlink-associate-user",
    CUSTOMER_PORTAL_GET_CONTRACTS_BY_USER_ID: "/admin/list-contracts-by-user-id",
    CUSTOMER_PORTAL_SEARCH_USER: "/admin/search-users",
    CUTOMER_PORTAL_BOOKED_CONTRACTS: "/admin/booked-contracts",
    CUSTOMER_PORTAL_DOCUMENTS_LIST: "/admin/list-allcodes",
    CUSTOMER_PORTAL_GET_ALL_EXTENSIONS: "/admin/list-allextensions",
    CUSTOMER_PORTAL_ADD_EXTENSION: "/admin/add-extension",
    CUSTOMER_PORTAL_DELETE_EXTENSION: "/admin/delete-extension",
    CUSTOMER_PORTAL_LIST_DOCUMENT_SIZE: "/admin/get-document-sizes-list",
    CUSTOMER_PORTAL_UPDATE_DOCUMENT_SIZE: "/admin/update-document-size",
    CUSTOMER_PORTAL_UPDATE_DOCUMENT_ACCESS: "/admin/update-document-code",
    CUSTOMER_PORTAL_PAYMENT_LIST: "/admin/payments/list-payments",
    CUSTOMER_PORTAL_PAYMENTS_TOTAL_COUNTS: "/admin/payment-stats",
    PAYMENT_SCHEDULER_REPORTS: "/admin/payments/scheduler/reports",
    PAYMENT_SCHEDULER_DOWNLOAD: "/admin/payments/scheduler",
    CUSTOMER_PORTAL_SUPPORT_TICKET_LIST: "/admin/support-tickets/list",
    CUSTOMER_PORTAL_SUPPORT_STATS_COUNT: "/admin//support-stats",
    CUSTOMER_PORTAL_BRAND_LIST: "/admin/get-all-brands",
    CUSTOMER_PORTAL_BRAND_UPDATE: "/admin/update-brand",
    CUSTOMER_PORTAL_DASHBOARD_STATS_FOR_PAYMENTS: "/admin/dashboard-stats",
    CUSTOMER_PORTAL_DASHBOARD_STATS_FOR_DOCUMENTS: "/admin/document-graph",
    CUSTOMER_PORTAL_BRAND_GET_BY_ID: "/admin/get-brand-by-id",
    CUSTOMER_PORTAL_FAQ_CREATE: "/admin/createfaq",
    CUSTOMER_PORTAL_FAQ_UPDATE: "/admin/updatefaq",
    CUSTOMER_PORTAL_FAQ_DELETE: "/admin/deletefaq",
    CUSTOMER_PORTAL_FAQ_LIST: "/admin/listfaqs",
    CUSTOMER_PORTAL_GET_USER_NOTIFICATION_DATA: "admin/notifications",
    CUSTOMER_PORTAL_USER_IMPERSONATE: "/admin/user-impersonate",
    CUSTOMER_PORTAL_REGISTER_LOGS: "/admin/users/register-logs",
    CUSTOMER_PORTAL_CHATBOT_FAQ_LIST: "/admin/listchatbotfaqs",
    CUSTOMER_PORTAL_CHATBOT_FAQ_CREATE: "/admin/chatbot-faq",
    CUSTOMER_PORTAL_CHATBOT_FAQ_UPDATE: "/admin/chatbot-faq",
    CUSTOMER_PORTAL_CHATBOT_FAQ_DELETE: "/admin/deletechatbotfaq",
    CUSTOMER_PORTAL_SELF_REGISTER: "register",
    CUSTOMER_PORTAL_SELF_REGISTER_SECURITY_QUESTIONS: "register/security-questions",
    CUSTOMER_PORTAL_SELF_REGISTER_VERIFY_DETAILS: "register/verify-details",
    CUSTOMER_PORTAL_SELF_REGISTER_VERIFY_OTP: "register/verify-otp",
    CUSTOMER_PORTAL_SELF_REGISTER_SET_PASSWORD: "register/set-register-password",
    CUSTOMER_PORTAL_SELF_REGISTER_RESEND_OTP: "register/resend-otp",
    CUSTOMER_PORTAL_SELF_REGISTER_LOGS: "register/logs",
    CUSTOMER_PORTAL_REGISTRATION_CREATE: "/admin/users/admin-registered-users",
    CUSTOMER_PORTAL_REGISTRATION_LIST: "/admin/users/admin-registered-users",
    CUSTOMER_PORTAL_REGISTRATION_RESEND_LINK: "/admin/users/admin-registered-users",
    CUSTOMER_PORTAL_MIGRATION_CHECK_EMAIL: "auth/migration/check-email",
    CUSTOMER_PORTAL_MIGRATION_VERIFY_OTP: "auth/migration/verify-otp",
    CUSTOMER_PORTAL_MIGRATION_SET_PASSWORD: "auth/migration/set-password",
};
